
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { SharedModule } from 'primeng/api';
import { SelectModule } from 'primeng/select';
import { PopoverModule } from 'primeng/popover';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { DividerModule } from 'primeng/divider';
import { MessagingService } from '../messaging.service';
import { NavPermissionsService } from './components/nav-bar/nav-permissions.service';
import { NavMenuService } from './components/nav-bar/nav-menu.service';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { environment } from '../../environments/environment';
import { AppPasswordResetDialogModule } from '../shared/components/app-password-reset-dialog/app-password-reset-dialog.module';

const firebase = environment.firebase;

@NgModule( {
	imports: [
		CommonModule,
		BrowserAnimationsModule,
		RouterModule,
		FormsModule,
		NgxMaskDirective,
		NgxMaskPipe,
		BsDropdownModule.forRoot(),
		CollapseModule,
		TabsModule.forRoot(),
		MenubarModule,
		MenuModule,
		SharedModule,
		SelectModule,
		PopoverModule,
		ButtonModule,
		BadgeModule,
		DividerModule,
		AngularFireModule.initializeApp( firebase ),
		AngularFireMessagingModule,
		AutoCompleteModule,
		NavBarComponent,
		AppPasswordResetDialogModule
	],
	providers: [
		MessagingService,
		provideNgxMask(),
		NavPermissionsService,
		NavMenuService,
	],
	exports: [ NavBarComponent ],
} )
export class CoreModule { }
